const marked = require("marked/src/marked.js");
export default marked;
